import { useAppTheme } from '@droplet-tech-code/core-elements/module/theme';
import { IconButton } from '@droplet-tech-code/core-elements/module/ui/Button';
import { useSearchState } from '@droplet-tech-code/core-elements/module/ui/Search/Search';
import { HStack, VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { Text } from '@droplet-tech-code/core-elements/module/ui/Text';
import { View } from '@droplet-tech-code/core-elements/module/ui/View';
import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { FerryCompanyExtraTicketConfig } from '@naus-code/naus-server-common-types';
import { useCallback } from 'react';
import { RefreshControl } from 'react-native-gesture-handler';

import { useAddFerryExtraTicketModal } from '~/components/Config/CompanyConfig/Modals/Tickets/Modals';
import { ConfigListSectionTitle } from '~/components/Config/ConfigLitst.SectionTitle';
import { FlatList } from '~/components/FlatList/FlatList';
import { ScreenPropExtraConfigs } from '~/navigation/Navigation.types';
import { translate } from '~/utils/translation.utils';

import { CompanyConfigItemHeader } from '../../CompanyConfig.ItemHeader';
import { companyConfigApi } from '../../CompanyConfigs.api';
import { ExtraConfig } from './ExtraConfig';

export const ExtraConfigs = ({ id }: { id: string }) => {
  const {
    list: extraConfigs,
    Search,
    isLoading,
    isFetching,
    refetch,
  } = useSearchState({
    hook: companyConfigApi.useGetFerryCompanyConfigQuery,
    style: {
      height: 47,
    },
    arg: id,
    keyToList: 'config.ticketTypeConfig.extraConfigs',
  });

  const { spacing } = useAppTheme();
  const { data } = companyConfigApi.useGetFerryCompanyConfigQuery(id);
  const { open: openAddVehicleTicketModal } = useAddFerryExtraTicketModal(id);

  const allExtraConfigs = extraConfigs.map((extraConfig) => {
    return { ...extraConfig, id: extraConfig.code };
  });
  const ItemSeparatorComponent = useCallback(() => <View my="1" />, []);

  const renderItem = (extraConfig: FerryCompanyExtraTicketConfig & { id: string }) => {
    return (
      <ExtraConfig
        companyId={id}
        check={data?.check || ''}
        extraConfig={extraConfig}
        key={extraConfig.id}
      />
    );
  };

  return (
    <VStack flex={1}>
      {isNativeMobile ? <CompanyConfigItemHeader id={id} /> : <></>}
      <VStack flex={1} p="2.5" space="2.5">
        <ConfigListSectionTitle>
          <HStack>
            <Text.Small flex={1} color="monochrome-mid">
              {translate('companyConfig.extraConfigs')}
            </Text.Small>
            <IconButton icon="plus" onPress={openAddVehicleTicketModal} />
          </HStack>
        </ConfigListSectionTitle>
        {Search}
        <FlatList
          refreshControl={
            <RefreshControl refreshing={isFetching} onRefresh={() => refetch()} />
          }
          contentContainerStyle={[
            {
              paddingTop: spacing[2.5],
            },

            isNativeMobile && { paddingHorizontal: spacing[2] },
          ]}
          simple
          scrollEnabled
          feedback={translate('companyConfig.emptyExtraConfigs')}
          isLoading={isLoading}
          data={allExtraConfigs}
          renderItem={renderItem}
          ItemSeparatorComponent={ItemSeparatorComponent}
        />
      </VStack>
    </VStack>
  );
};

export const ExtraConfigsScreen = (props: ScreenPropExtraConfigs) => {
  return <ExtraConfigs id={props.route.params.id} />;
};
